import * as React from 'react';

import { calculateMedianTransaction } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface IMedianTransactionRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
  negateAmount?: boolean;
}

const MedianTransactionRow = ({
  transactions,
  dateRange,
  colored = false,
  showSign = false,
  negateAmount = false,
}: IMedianTransactionRowProps) => {
  const rawValue = React.useMemo(() => calculateMedianTransaction(transactions, dateRange), [transactions, dateRange]);

  const value = negateAmount ? -rawValue : rawValue;

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return (
    <Widget.Row variant="summary" label="Median transaction" value={formattedValue} valueClassName={valueClassName} />
  );
};

export default MedianTransactionRow;
